import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconNetPay: React.FC<Props> = ({
  width = 18,
  height = 14,
  // color = "#FFFFFF",
  // disabled = false,
}: Props) => (
  <svg width={width} 
        height={height} 
        viewBox="0 0 18 14" fill="none" 
        xmlns="http://www.w3.org/2000/svg">

        <path d="M9 3.87501C7.27667 3.87501 5.875 5.27667 5.875 7.00001C5.875 8.72334 7.27667 10.125 9 10.125C10.7233 10.125 12.125 8.72334 12.125 7.00001C12.125 5.27667 10.7233 3.87501 9 3.87501ZM9 8.87501C7.96583 8.87501 7.125 8.03417 7.125 7.00001C7.125 5.96584 7.96583 5.12501 9 5.12501C10.0342 5.12501 10.875 5.96584 10.875 7.00001C10.875 8.03417 10.0342 8.87501 9 8.87501ZM14 0.541672H4C1.985 0.541672 0.875 1.65167 0.875 3.66667V10.3333C0.875 12.3483 1.985 13.4583 4 13.4583H14C16.015 13.4583 17.125 12.3483 17.125 10.3333V3.66667C17.125 1.65167 16.015 0.541672 14 0.541672ZM15.875 10.3333C15.875 11.6475 15.3142 12.2083 14 12.2083H4C2.68583 12.2083 2.125 11.6475 2.125 10.3333V3.66667C2.125 2.35251 2.68583 1.79167 4 1.79167H14C15.3142 1.79167 15.875 2.35251 15.875 3.66667V10.3333ZM4.83333 7.00001C4.83333 7.46001 4.46 7.83334 4 7.83334C3.54 7.83334 3.16667 7.46001 3.16667 7.00001C3.16667 6.54001 3.54 6.16667 4 6.16667C4.46 6.16667 4.83333 6.54001 4.83333 7.00001ZM14.8333 7.00001C14.8333 7.46001 14.46 7.83334 14 7.83334C13.54 7.83334 13.1667 7.46001 13.1667 7.00001C13.1667 6.54001 13.54 6.16667 14 6.16667C14.46 6.16667 14.8333 6.54001 14.8333 7.00001Z" fill="#3E454D"/>
  </svg>
);

export default IconNetPay;
